import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Budget from "../assets/images/budget.svg";
import Goals from "../assets/images/goals.svg";
import {ASSETS_URL} from "../api/constants";
const WhyPreQualified = ({ data, loading }) => {


  return (
    <div className="why-pre-qualified common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>{data?.title || ""}</h2>
          <p>{data?.subtitle || ""}</p>
        </div>

        <Row className="g-4 justify-content-center">
          {(data?.cards || []).map((card, index) => (
            <Col key={index} md={6} lg={5}>
              <Card>
                <img src={`${ASSETS_URL}${card.icon}`} alt="" />
                <h5>{card.title}</h5>
                <p>{card.subtitle}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default WhyPreQualified;
